export const IMAGES = {
  PICKUP: {
    src: '/assets/pickup.png',
    alt: 'Pickup',
  },
  DOTTED_CONNECTOR: {
    src: '/assets/dotted-connector.png',
    alt: 'Dotted Connector',
  },
  DROP: { src: '/assets/drop.png', alt: 'Drop' },
};
